import { apiClient } from "@wtf/shared/api/utils/api-client";
import {
  GetCollectionCoverPresignResponse,
  GetLookCoverPresignResponse,
  GetProductImagePresignResponse,
  GetUserAvatarPresignResponse,
  GetUserCoverPresignResponse,
  GetFeedbackAttachmentPresignResponse,
  GetTryOnPhotoPresignResponse,
} from "@wtf/shared";

const BASE_UPLOADS = "api/uploads";

/**
 * Generate a presigned URL for direct upload of a collection cover image (no collectionId required)
 */
export async function getCollectionCoverPresignUrl(data: {
  fileName: string;
  contentType: string;
}): Promise<GetCollectionCoverPresignResponse> {
  return apiClient<GetCollectionCoverPresignResponse>(`${BASE_UPLOADS}/collections/cover/presign`, "POST", data);
}

/**
 * Generate a presigned URL for direct upload of a look cover image (no lookId required)
 */
export async function getLookCoverPresignUrl(data: {
  fileName: string;
  contentType: string;
}): Promise<GetLookCoverPresignResponse> {
  return apiClient<GetLookCoverPresignResponse>(`${BASE_UPLOADS}/looks/cover/presign`, "POST", data);
}

/**
 * Generate a presigned URL for direct upload of a product image (no productId required)
 */
export async function getProductImagePresignUrl(data: {
  fileName: string;
  contentType: string;
}): Promise<GetProductImagePresignResponse> {
  return apiClient<GetProductImagePresignResponse>(`${BASE_UPLOADS}/products/images/presign`, "POST", data);
}

/**
 * Generate a presigned URL for direct upload of a user avatar (no userId required)
 */
export async function getUserAvatarPresignUrl(data: {
  fileName: string;
  contentType: string;
}): Promise<GetUserAvatarPresignResponse> {
  return apiClient<GetUserAvatarPresignResponse>(`${BASE_UPLOADS}/users/avatar/presign`, "POST", data);
}

/**
 * Generate a presigned URL for direct upload of a user cover photo (no userId required)
 */
export async function getUserCoverPresignUrl(data: {
  fileName: string;
  contentType: string;
}): Promise<GetUserCoverPresignResponse> {
  return apiClient<GetUserCoverPresignResponse>(`${BASE_UPLOADS}/users/cover/presign`, "POST", data);
}

/**
 * Generate a presigned URL for direct upload of a feedback attachment
 */
export async function getFeedbackAttachmentPresignUrl(data: {
  fileName: string;
  contentType: string;
}): Promise<GetFeedbackAttachmentPresignResponse> {
  return apiClient<GetFeedbackAttachmentPresignResponse>(`${BASE_UPLOADS}/feedback/attachment/presign`, "POST", data);
}

/**
 * Generate a presigned URL for direct upload of a try-on photo
 */
export async function getTryOnPhotoPresignUrl(data: {
  fileName: string;
  contentType: string;
  setAsDefault?: boolean;
}): Promise<GetTryOnPhotoPresignResponse> {
  return apiClient<GetTryOnPhotoPresignResponse>("api/try-on/photos", "POST", data);
}

/**
 * Finalize an upload by converting HEIC to JPEG if needed
 */
export async function finalizeUpload(data: { key: string; contentType: string }): Promise<{
  success: boolean;
  converted: boolean;
  originalUrl: string;
  finalUrl: string;
  originalKey: string;
  finalKey: string;
}> {
  return apiClient(`${BASE_UPLOADS}/finalize`, "POST", data);
}

export const uploadsApi = {
  getCollectionCoverPresignUrl,
  getLookCoverPresignUrl,
  getProductImagePresignUrl,
  getUserAvatarPresignUrl,
  getUserCoverPresignUrl,
  getFeedbackAttachmentPresignUrl,
  getTryOnPhotoPresignUrl,
  finalizeUpload,
};
